import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Instagram, Mail, MapPin, Clock, Phone } from "lucide-react";
import { PageHeader } from "../components/site/PageHeader";
import { Reveal, Eyebrow } from "../components/site/Motion";
import { WeddingForm } from "../components/site/WeddingForm";
import { SITE, waLink } from "../lib/site";

const ITEMS = [
  { icon: Phone, label: "WhatsApp", value: SITE.phone, href: waLink(), id: "whatsapp" },
  { icon: Mail, label: "Email", value: SITE.email, href: `mailto:${SITE.email}`, id: "email" },
  { icon: Instagram, label: "Instagram", value: SITE.igHandle, href: SITE.instagram, id: "instagram" },
  { icon: MapPin, label: "Negozio", value: SITE.address, id: "address" },
  { icon: Clock, label: "Orari", value: SITE.hours, id: "hours" },
];

export default function Contact() {
  const { hash } = useLocation();
  useEffect(() => {
    if (hash !== "#consulenza") return undefined;
    const t = setTimeout(() => {
      const el = document.getElementById("consulenza");
      if (el && window.__lenis) window.__lenis.scrollTo(el, { offset: -100 });
      else if (el) el.scrollIntoView();
    }, 400);
    return () => clearTimeout(t);
  }, [hash]);

  return (
    <main data-testid="contact-page" className="bg-cream">
      <PageHeader testid="contact-header" eyebrow="Contatti" lines={["Parliamo", "di fiori"]}
        intro="Per ordini in negozio scrivimi su WhatsApp. Per il vostro matrimonio compilate il modulo di consulenza: mi aiuta a conoscervi prima di incontrarci." />
      <section className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12 pb-28 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4 space-y-1">
          {ITEMS.map(({ icon: Icon, label, value, href, id }, i) => {
            const body = (
              <span className="flex items-start gap-4 py-5 border-b border-stone">
                <Icon className="w-5 h-5 mt-1 text-terra shrink-0" />
                <span className="min-w-0">
                  <span className="block font-mono text-[11px] uppercase tracking-[0.22em] text-ash">{label}</span>
                  <span className="block mt-1 font-serif text-xl sm:text-2xl text-ink break-words whitespace-pre-line">{value}</span>
                </span>
              </span>
            );
            return (
              <Reveal key={id} delay={i * 0.06}>
                {href ? <a href={href} target="_blank" rel="noreferrer" data-testid={`contact-${id}`} className="block hover:translate-x-1 transition-transform">{body}</a> : <div data-testid={`contact-${id}`}>{body}</div>}
              </Reveal>
            );
          })}
        </div>
        <div id="consulenza" className="lg:col-span-8 scroll-mt-28">
          <Eyebrow>Modulo consulenza matrimoni</Eyebrow>
          <h2 className="mt-4 mb-8 font-serif text-4xl sm:text-5xl text-ink leading-tight">Futuri sposi, <em className="text-cypress">raccontatevi.</em></h2>
          <WeddingForm />
        </div>
      </section>
    </main>
  );
}
